import { getConfig } from './utils/config.js';

/** @type {import('@auth0/auth0-vue').Auth0VueClientOptions} */
export default {
  domain: getConfig("VITE_AUTH0_DOMAIN"),
  clientId: getConfig('VITE_AUTH0_CLIENT_ID'),
  authorizationParams: {
    redirect_uri: getConfig("VITE_AUTH0_REDIRECT_URI") || window.location.origin
  },
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
}